var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible && _vm.effectDisplay !== undefined)?_c('span',[(_vm.br)?_c('br'):_vm._e(),_vm._v(" "+_vm._s(_vm.labelDisplay)+_vm._s(_vm.effectDisplay)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }